import dogLowerIncisors from "./dog_lower_incisors.svg";
import dogUpperIncisors from "./dog_upper_incisors.svg";

const incisors = {
  dogLowerIncisors,
  dogUpperIncisors,
};

export default incisors;
